import React from 'react';
import { AulaCard } from '../AulaCard/AulaCard';
import { Aula } from '../../../domain/entities/Aula';
import './Sections.css';

interface AulasSectionProps {
  aulas: Aula[];
}

export const AulasSection: React.FC<AulasSectionProps> = ({ aulas }) => {
  return (
    <section className="content-section">
      <h2 className="section-title">Aulas de Pandeiro</h2>
      <p className="section-subtitle">
        Aprenda com os melhores professores em um ambiente acolhedor
      </p>
      
      {aulas.length > 0 ? (
        <div className="aulas-container">
          {aulas.map((aula, index) => (
            <AulaCard 
              key={aula.id.value} 
              instructor={aula.instructor.value} 
              day={aula.day.value}
              url={aula.url.value}
              instagram={aula.instagram?.value}
            />
          ))}
        </div>
      ) : (
        <div className="no-aulas">
          <p>Nenhuma aula disponível</p>
          <p>Entre em contato para mais informações sobre horários</p>
        </div>
      )}
    </section>
  );
}; 